import React, { Component } from 'react';
import InputField from '../../../components/inputs/inputField';
import TextAreaField from '../../../components/inputs/textAreaField';
import SelectField from '../../../components/inputs/selectField';
import ToggleField from '../../../components/inputs/toggleField';
import FieldModal from '../../../components/modals/fieldModal';

const durationOptions = [
	{value: 'minutes', label: 'Minutes'},
	{value: 'hours', label: 'Hours'},
];
class AddBookingModal extends Component {
	constructor(props) {
		super(props);
		const eventOptions = [];
		if(props.eventMap) {
			console.log(props.eventMap);
			Object.keys(props.eventMap).forEach(eventId => {
				eventOptions.push({ value: eventId, label: props.eventMap[eventId].name });
			});
		}
		this.state = {
			bookingPage: {
				name: '',
				pageSlug: '',
				description: '',
				meetingDuration: 30,
				durationUnit: 'minutes',
				isPartofEvent: false,
				activeEvent: null,
			},
			pageSlugEdited: false,
			requiredFields: {
				name: false,
				meetingDuration: false,
				pageSlug: false,
				activeEvent: false  
			},
			eventOptions: eventOptions,
			submitting: false,
			formIsValid: false
		};
	}

	validateForm = () => {
		const { bookingPage, requiredFields } = this.state;
		let formIsValid = true;
		
		// Check required fields
		Object.keys(requiredFields).forEach((key) => {
			if (key === 'activeEvent' && !bookingPage.isPartofEvent) {
				return;
			}
			if (!bookingPage[key] || bookingPage[key] === '') {
				formIsValid = false;
			}
		});

		// Validate meeting duration
		const duration = Number(bookingPage.meetingDuration);
		if (isNaN(duration) || (bookingPage.durationUnit === 'minutes' && (duration < 5 || duration > 180)) || (bookingPage.durationUnit === 'hours' && (duration < 1 || duration > 8))) {
			formIsValid = false;
		}
		
		this.setState({ formIsValid });
	}

	handleInputChange = (field, value) => {
		const updates = {
			...this.state.bookingPage,
			[field]: value
		};
		
		if (field === 'isPartofEvent' && !value) {
			updates.activeEvent = null;
		}
		
		this.setState({ 
			bookingPage: updates
		}, this.validateForm);
	};

	handleTitleChange = (e) => {
		const { pageSlugEdited } = this.state;
		const value = e.target.value;
		let pageSlug = this.state.bookingPage.pageSlug;
		if(!pageSlugEdited) {
			// Automatically generate page slug from name if not edited, account for special characters
			pageSlug = value.replace(/\s+/g, '-').toLowerCase().replace(/[^\w-]+/g, '');
		}
		this.setState({
			bookingPage: {
				...this.state.bookingPage,
				name: value,
				pageSlug: pageSlug
			}
		});
	}

	handlePageSlugChange = (e) => {
		const value = e.target.value.trim();
		this.setState({
			bookingPage: {
				...this.state.bookingPage,
				pageSlug: value
			},
			pageSlugEdited: value !== ""
		}, this.validateForm);
	}

	createBookingPage = async () => {
		this.setState({ submitting: true });
		const bookingPageData = {
			name: this.state.bookingPage.name.trim(),
			description: this.state.bookingPage.description.trim(),
			pageSlug: this.state.bookingPage.pageSlug.trim(),
			meetingDuration: parseInt(this.state.bookingPage.meetingDuration),
			durationUnit: this.state.bookingPage.durationUnit, 
			isPartofEvent: this.state.bookingPage.isPartofEvent
		};

		if(this.state.bookingPage.isPartofEvent) {
			bookingPageData.eventId = this.state.bookingPage.activeEvent;
		}

		const success = await this.props.handleSubmit(bookingPageData);
		if (!success) {
			this.setState({ submitting: false });
			return;
		}
	};

	render() {
		const { isOpen, toggle } = this.props;
		const { bookingPage, requiredFields, submitting, formIsValid } = this.state;
		return (
			<FieldModal
				isOpen={isOpen}
				toggle={toggle}
				size="medium"
				actionButton={this.createBookingPage}
				actionButtonLabel={submitting ? 'Creating Booking Page...' : 'Create Booking Page'}
				actionButtonDisabled={!formIsValid || submitting}
				bodyContent={() => (
					<div className="sectionBody w-100">
						<div style={{ textAlign: 'center' }}>
							<h1>Create New Booking Page</h1>
							<div className='mb-20 mt-10'>
								<p className='mb-10'>Set up a new page to schedule meetings</p>
							</div>
						</div>

						<div className='flex flex-wrap jcc' style={{ overflowX: 'hidden', maxHeight: 'calc(100% - 96px)' }}>
							<div className="sectionBlock" style={{ maxWidth: 600, paddingLeft: 1 }}>
								<InputField
									label="Booking Name"
									placeholder="e.g., VIP Tours, Sales Meeting, etc."
									value={bookingPage.name}
									required={true}
									errorTrigger={requiredFields.name}
									errorMessage="Booking page name is required"
									onChange={(e) => this.handleTitleChange(e)}
								/>

								<TextAreaField
									label="Description"
									placeholder="Brief description of what this booking is for..."
									value={bookingPage.description}
									rows={3}
									onChange={(e) => this.handleInputChange('description', e.target.value)}
									required={true}
								/>
								<InputField
									label="Booking Page Address"
									prefix={<span className="lightBody">{this.props.organization && (this.props.organization.hostname ? `https://${this.props.organization.hostname}/0/` : `https://${this.props.organization.identifier}.simple.events/0/`) }</span>}
									placeholder=""
									value={bookingPage.pageSlug}
									errorTrigger={requiredFields.pageSlug}
									errorMessage="Page slug is required"
									onChange={(e) => this.handlePageSlugChange(e)}
								/>

								<div className="flex w-100 gap20">
										<InputField
											label="Meeting Duration"
											value={bookingPage.meetingDuration}
											errorTrigger={requiredFields.meetingDuration}
											errorMessage="Meeting duration is required"
											type="number"
											max={bookingPage.durationUnit === 'minutes' ? 1440 : 24}
											onChange={(e) => {
												const value = e.target.value;
												if (!(value < 1 || (bookingPage.durationUnit === 'minutes' && value > 1440) || (bookingPage.durationUnit === 'hours' && value > 24))) {
													this.handleInputChange('meetingDuration', e.target.value)
												}
											}}
										/>
										<SelectField
											label="Duration Unit"
											value={durationOptions.find(opt => opt.value === bookingPage.durationUnit)}
											options={durationOptions}
											required={true}
											errorTrigger={requiredFields.durationUnit}
											onChange={(option) => this.handleInputChange('durationUnit', option.value)}
										/>
								</div>

								<ToggleField 
									label="Connect to Event" 
									icons={false} 
									checked={bookingPage.isPartofEvent} 
									onChange={(e) => this.handleInputChange('isPartofEvent', e.target.checked)} 
								/>
								{bookingPage.isPartofEvent && (
									<SelectField
										label="Select Event"
										value={this.state.eventOptions.find(opt => opt.value === bookingPage.activeEvent)}
										options={this.state.eventOptions}
										required={true}
										errorTrigger={requiredFields.activeEvent && !bookingPage.activeEvent}
										errorMessage="Please select an event"
										onChange={(option) => this.handleInputChange('activeEvent', option.value)}
									/>
								)}
							</div>
						</div>
					</div>
				)}
			/>
		);
	}
}

export default AddBookingModal;
